const eS3DataType = {
  Alerts: { value: 1, name: 'Alerts' },
  Audits: { value: 2, name: 'Audits' }
};

export default eS3DataType;
